// src/utils/validateSection.ts
import type { Section, QuestionCondition, AnswerValue } from '../types/types';

function isConditionMet(
  condition: QuestionCondition | undefined,
  answers: Record<string, AnswerValue>
): boolean {
  if (!condition) return true;
  const dependencyId = condition.depends_on || condition.question_id;
  if (!dependencyId) return true;
  const currentValue = answers[dependencyId];
  return currentValue === condition.value;
}

export function validateSection(
  section: Section,
  answers: Record<string, AnswerValue>
): { valid: boolean; errors: Record<string, string> } {
  const errors: Record<string, string> = {};

  for (const q of section.questions) {
    const shouldRender = isConditionMet(q.condition, answers);
    if (!shouldRender) continue;

    const value = answers[q.id];

    if (q.required) {
      const isEmpty =
        value === undefined ||
        value === null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        errors[q.id] = 'This question is required.';
        continue;
      }
    }

    // if (q.type === 'number') {
    //   const num = Number(value);
    //   if (!isNaN(num)) {
    //     if (q.min !== undefined && num < q.min)
    //       errors[q.id] = `Value must be at least ${q.min}.`;
    //     if (q.max !== undefined && num > q.max)
    //       errors[q.id] = `Value must be at most ${q.max}.`;
    //   }
    // }

    // if (q.type === 'text' && typeof value === 'string') {
    //   if (q.min_length && value.length < q.min_length)
    //     errors[q.id] = `Must be at least ${q.min_length} characters.`;
    //   if (q.max_length && value.length > q.max_length)
    //     errors[q.id] = `Must be at most ${q.max_length} characters.`;
    // }
  }

  return { valid: Object.keys(errors).length === 0, errors };
}
